import { Button } from '@ds';
import { MdOutlineClear } from 'react-icons/md';
import { FilterDropdown } from '@ui';
import { BANNED_DRIVERS_AFFILATION_LIST } from '@/constants/form.constants';
import { UseFiltersType } from '@/hooks/useFilters';
import { DriverListFilters } from '@/api/apis/resources';
import { FILTERS_NAMES } from '../config';

type BannedDriversFiltersProps = UseFiltersType<DriverListFilters>;

export const BannedDriversFilters = ({
  filters,
  hasFilters,
  updateFilters,
  clearFilters,
}: BannedDriversFiltersProps) => {
  return (
    <div className="flex gap-7 items-center">
      <FilterDropdown
        title={FILTERS_NAMES.affilation}
        items={BANNED_DRIVERS_AFFILATION_LIST}
        selectedKeys={filters.affiliationTypes ?? []}
        mode="multiple"
        onSelectedKeysChange={(values) => updateFilters(values, 'affiliationTypes')}
      />
      {hasFilters && (
        <Button startContent={<MdOutlineClear size={18} />} size="sm" variant="light" onClick={clearFilters}>
          Clear all
        </Button>
      )}
    </div>
  );
};
